import React from "react";

type Props = {
  title: string;
  url: string;
};

const MessageVideo: React.FC<Props> = ({ title, url }): JSX.Element => {
  return (
    <video width="150" height="150" id={title} controls>
      <source src={url} type="video/mp4" />
    </video>
  );
};

export default MessageVideo;
